var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"user-headers"},_vm._l((_vm.getHeaders),function(header){return _c('div',{key:header.value,staticClass:"user-headers__element",class:{ 'user-headers__element_name': header.value === 'name' },style:(`width: ${header.width}px`)},[_c('span',{staticClass:"user-headers__text_light"},[_vm._v(" "+_vm._s(header.name)+" ")])])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }